export default __webpack_public_path__ + "media/zurb/img/lab/playground/responsive-email-templates/sidebar-hero-ead85b566aa5e4a11f86da0edba7114a.jpg";